module.exports = __webpack_public_path__ + "img/keycap-digit-zero.5effbd4a.png";